import { isElementOnView } from "../utils/isElementOnView"

const planCategory = {
    individual: "Personal",
    business: "Business-Education",
    menuButton: "Menu button"
}

const plans = {
    individual: {
        home: {
            name: "Individual",
            id: "i0",
            category: planCategory.individual,
            price: "1.67"
        },
        basic: {
            name: "Basic",
            id: "i1",
            category: planCategory.individual,
            price: "1.67"
        },
        personal: {
            name: "Personal",
            id: "i2",
            category: planCategory.individual,
            price: "2.99"
        },
        home: {
            name: "Home",
            id: "i3",
            category: planCategory.individual,
            price: "4.49"
        },
        pro: {
            name: "Pro",
            id: "i4",
            category: planCategory.individual,
            price: "5.99"
        }
    },

    business: {
        home: {
            name: "Business",
            id: "b0",
            category: planCategory.business,
            price: "20.83"
        },
        suite: {
            name: "Suite",
            id: "10",
            category: planCategory.business,
            price: "15.00"
        },
        smb: {
            name: "SMB",
            id: "11",
            category: planCategory.business,
            price: "30.00"
        },
        ultimate: {
            name: "Ultimate",
            id: "12",
            category: planCategory.business,
            price: "80.00"
        }
    },

    education: {
        name: "Education",
        id: "b4",
        category: planCategory.business,
        price: "custom"
    },

    menuButton: {
        name: "Menu button",
        id: "mb",
        category: planCategory.menuButton
    }
}

let currentPlan = {}
let isDataViewed = false

const homePageProductsList = [
    plans.individual.home, plans.business.home, plans.education, plans.menuButton
]
const individualPageProductList = [
    plans.individual.basic, plans.individual.personal, plans.individual.home, plans.individual.pro, plans.menuButton
]

const businessPageProductList = [
    plans.business.suite, plans.business.smb, plans.business.ultimate, plans.education, plans.menuButton
]

function plansViewed (sectionSelector, plans) {
    let el = document.querySelector(sectionSelector)
    let isVisible = isElementOnView(el)

    if (isVisible && !isDataViewed) {
        // dataLayer is set by google tag manager script
        dataLayer.push({
            "event": "productView",
            "ecommerce": {
                "detail": {
                    "products": plans
                }
            }
        })

        isDataViewed = true
    }
}

function buttonClickTrack (buttonSelector, plan, isNavButton) {
    let button = document.querySelector(buttonSelector)

    if (button) {
        button.addEventListener("click", function() {
            plan.variant = document.location.pathname
            plan.dimension1 = isNavButton ? "0" : "2"
            dataLayer.push({
                "event": "addToCart",
                "ecommerce": {
                    "add": {
                        "products": [plan]
                    }
                }
            })
            currentPlan = plan
        })
    }
}

function setPlanIds (buttonSelector, plan) {
    let button = document.querySelector(buttonSelector)
    if (button) {
        let id = button.getAttribute("data-id")
        plan.id = id
    }
}

export const googleTagManagerEnhancedEcommerceSignUpSuccess = () => {
    let plan = currentPlan
    plan.variant = window.location.pathname
    dataLayer.push({
        "event": "productCheckout",
            "ecommerce": {
            "checkout": {
                "actionField": {"step": 1},
                "products": [plan]
            }
        },
    });
}


export const googleTagManagerEnhancedEcommerce = () =>{
    document.addEventListener("scroll", function() {
        let homePage = ".section-plans"
        let individualPlans = ".individual-plans"
        let businessPlans = ".business-plans"

        // views
        plansViewed(homePage, homePageProductsList)
        plansViewed(individualPlans, individualPageProductList)
        plansViewed(businessPlans, businessPageProductList)
    })

    // track button clicks on plans and nav manu
    let navMenuButton = ".site-header__button"
    let basicPlanButton = ".ga-individual-basic"
    let personalPlanButton = ".ga-individual-personal"
    let homePlanButton = ".ga-individual-home"
    let proPlanButton = ".ga-individual-pro"
    let ultimatePlanButton = ".ga-business-ultimate"
    let smbPlanButton = ".ga-business-smb"
    let suitePlanButton = ".ga-business-suite"

    // set ids
    setPlanIds(basicPlanButton, plans.individual.basic)
    setPlanIds(personalPlanButton, plans.individual.personal)
    setPlanIds(homePlanButton, plans.individual.home)
    setPlanIds(proPlanButton, plans.individual.pro)
    setPlanIds(ultimatePlanButton, plans.business.ultimate)
    setPlanIds(smbPlanButton, plans.business.smb)
    setPlanIds(suitePlanButton, plans.business.suite)

    buttonClickTrack(navMenuButton, plans.menuButton, true)
    // individual plans
    buttonClickTrack(basicPlanButton, plans.individual.basic)
    buttonClickTrack(personalPlanButton, plans.individual.personal)
    buttonClickTrack(homePlanButton, plans.individual.home)
    buttonClickTrack(proPlanButton, plans.individual.pro)
    // business plans
    buttonClickTrack(ultimatePlanButton, plans.business.ultimate)
    buttonClickTrack(smbPlanButton, plans.business.smb)
    buttonClickTrack(suitePlanButton, plans.business.suite)
}
